export const defaultCountry = "USA";
export const defaultBoderlessCountryName = "UNITED STATES OF AMERICA";
export const defaultCurrency = "USD";

export const relationOptions = [
  { label: "Father", value: "FATHER" },
  { label: "Step Father", value: "STEP FATHER" },
  { label: "Mother", value: "MOTHER" },
  { label: "Step Mother", value: "STEP MOTHER" },
  { label: "Son", value: "SON" },
  { label: "Step Son", value: "STEP SON" },
  { label: "Son's Wife", value: "SON'S WIFE" },
  { label: "Daughter", value: "DAUGHTER" },
  { label: "Daughter's Husband", value: "DAUGHTER'S HUSBAND" },
  { label: "Brother", value: "STEP BROTHER" },
  { label: "Step Brother", value: "STEP BROTHER" },
  { label: "Sister", value: "SISTER" },
  { label: "Step Sister", value: "STEP SISTER" },
  { label: "Husband", value: "HUSBAND" },
  { label: "Wife", value: "WIFE" },
];

export const remitterTypeOptions = [
  { label: "Guardian", value: "Guardian" },
  { label: "Self", value: "Self" },
];

// to code country code of two words
// "https://sto-assets.s3.ap-south-1.amazonaws.com/country-flags/usa.svg"
// https://flagcdn.com/dz.svg
export const currencyData = {
  USD: { name: "US Dollar", symbol: "$", flag: "🇺🇸", countryCode: "us" },
  EUR: { name: "Euro", symbol: "€", flag: "🇪🇺", countryCode: "eu" },
  GBP: { name: "British Pound", symbol: "£", flag: "🇬🇧", countryCode: "gb" },
  INR: { name: "Indian Rupee", symbol: "₹", flag: "🇮🇳", countryCode: "in" },
  JPY: { name: "Japanese Yen", symbol: "¥", flag: "🇯🇵", countryCode: "jp" },
  CNY: { name: "Chinese Yuan", symbol: "¥", flag: "🇨🇳", countryCode: "cn" },
  AUD: {
    name: "Australian Dollar",
    symbol: "$",
    flag: "🇦🇺",
    countryCode: "au",
  },
  CAD: { name: "Canadian Dollar", symbol: "$", flag: "🇨🇦", countryCode: "ca" },
  SGD: { name: "Singapore Dollar", symbol: "$", flag: "🇸🇬", countryCode: "sg" },
  HKD: { name: "Hong Kong Dollar", symbol: "$", flag: "🇭🇰", countryCode: "hk" },
  AED: { name: "UAE Dirham", symbol: "د.إ", flag: "🇦🇪", countryCode: "ae" },
  SAR: { name: "Saudi Riyal", symbol: "﷼", flag: "🇸🇦", countryCode: "sa" },
  QAR: { name: "Qatari Riyal", symbol: "﷼", flag: "🇶🇦", countryCode: "qa" },
  KWD: { name: "Kuwaiti Dinar", symbol: "د.ك", flag: "🇰🇼", countryCode: "kw" },
  BHD: {
    name: "Bahraini Dinar",
    symbol: ".د.ب",
    flag: "🇧🇭",
    countryCode: "bh",
  },
  OMR: { name: "Omani Rial", symbol: "﷼", flag: "🇴🇲", countryCode: "om" },
  ZAR: {
    name: "South African Rand",
    symbol: "R",
    flag: "🇿🇦",
    countryCode: "za",
  },
  KES: {
    name: "Kenyan Shilling",
    symbol: "KSh",
    flag: "🇰🇪",
    countryCode: "ke",
  },
  NGN: { name: "Nigerian Naira", symbol: "₦", flag: "🇳🇬", countryCode: "ng" },
  GHS: { name: "Ghana Cedi", symbol: "₵", flag: "🇬🇭", countryCode: "gh" },
  EGP: { name: "Egyptian Pound", symbol: "£", flag: "🇪🇬", countryCode: "eg" },
  TRY: { name: "Turkish Lira", symbol: "₺", flag: "🇹🇷", countryCode: "tr" },
  CHF: { name: "Swiss Franc", symbol: "Fr", flag: "🇨🇭", countryCode: "ch" },
  SEK: { name: "Swedish Krona", symbol: "kr", flag: "🇸🇪", countryCode: "se" },
  NOK: { name: "Norwegian Krone", symbol: "kr", flag: "🇳🇴", countryCode: "no" },
  DKK: { name: "Danish Krone", symbol: "kr", flag: "🇩🇰", countryCode: "dk" },
  PLN: { name: "Polish Zloty", symbol: "zł", flag: "🇵🇱", countryCode: "pl" },
  CZK: { name: "Czech Koruna", symbol: "Kč", flag: "🇨🇿", countryCode: "cz" },
  HUF: {
    name: "Hungarian Forint",
    symbol: "Ft",
    flag: "🇭🇺",
    countryCode: "hu",
  },
  RUB: { name: "Russian Ruble", symbol: "₽", flag: "🇷🇺", countryCode: "ru" },
  KRW: { name: "South Korean Won", symbol: "₩", flag: "🇰🇷", countryCode: "kr" },
  THB: { name: "Thai Baht", symbol: "฿", flag: "🇹🇭", countryCode: "th" },
  MYR: {
    name: "Malaysian Ringgit",
    symbol: "RM",
    flag: "🇲🇾",
    countryCode: "my",
  },
  IDR: {
    name: "Indonesian Rupiah",
    symbol: "Rp",
    flag: "🇮🇩",
    countryCode: "id",
  },
  PHP: { name: "Philippine Peso", symbol: "₱", flag: "🇵🇭", countryCode: "ph" },
  VND: { name: "Vietnamese Dong", symbol: "₫", flag: "🇻🇳", countryCode: "vn" },
  NZD: {
    name: "New Zealand Dollar",
    symbol: "$",
    flag: "🇳🇿",
    countryCode: "nz",
  },
  BRL: { name: "Brazilian Real", symbol: "R$", flag: "🇧🇷", countryCode: "br" },
  MXN: { name: "Mexican Peso", symbol: "$", flag: "🇲🇽", countryCode: "mx" },
  ARS: { name: "Argentine Peso", symbol: "$", flag: "🇦🇷", countryCode: "ar" },
  CLP: { name: "Chilean Peso", symbol: "$", flag: "🇨🇱", countryCode: "cl" },
};
